
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125 2H1.875C0.839453 2 0 2.89542 0 4V16C0 17.1046 0.839453 18 1.875 18H18.125C19.1605 18 20 17.1046 20 16V4C20 2.89542 19.1605 2 18.125 2ZM17.8906 16H2.10938C2.04721 16 1.9876 15.9737 1.94365 15.9268C1.89969 15.8799 1.875 15.8163 1.875 15.75V4.25C1.875 4.1837 1.89969 4.12011 1.94365 4.07322C1.9876 4.02634 2.04721 4 2.10938 4H17.8906C17.9528 4 18.0124 4.02634 18.0564 4.07322C18.1003 4.12011 18.125 4.1837 18.125 4.25V15.75C18.125 15.8163 18.1003 15.8799 18.0564 15.9268C18.0124 15.9737 17.9528 16 17.8906 16V16ZM5 5.66667C4.13707 5.66667 3.4375 6.41288 3.4375 7.33333C3.4375 8.25379 4.13707 9 5 9C5.86293 9 6.5625 8.25379 6.5625 7.33333C6.5625 6.41288 5.86293 5.66667 5 5.66667ZM3.75 14H16.25V10.6667L12.8314 7.02021C12.6484 6.82496 12.3516 6.82496 12.1685 7.02021L7.5 12L5.95645 10.3535C5.7734 10.1583 5.4766 10.1583 5.29352 10.3535L3.75 12V14Z"}})])
          )
        }
      }
    